var exports = {
  "v5": "dialogBody__Ak3lY7",
  "wS": "grow__DVlHer",
  "Zd": "form__r_Jqv2",
  "xQ": "footerContainer__bMMyYK",
};

module.exports = exports;
